import { render, staticRenderFns } from "./partyAffairsList.vue?vue&type=template&id=2d06375c&scoped=true"
import script from "./partyAffairsList.vue?vue&type=script&lang=js"
export * from "./partyAffairsList.vue?vue&type=script&lang=js"
import style0 from "./partyAffairsList.vue?vue&type=style&index=0&id=2d06375c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06375c",
  null
  
)

export default component.exports